var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _g2, _path8, _path9, _g3, _path10, _path11, _g4, _path12, _path13, _path14, _path15, _g5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 229,
    viewBox: "0 0 266 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.766 184.257C177.364 184.257 211.172 150.346 211.172 108.621C211.172 66.8974 177.364 32.9868 135.766 32.9868C94.0129 32.9868 60.3608 66.741 60.3608 108.621C60.3608 150.346 94.0129 184.257 135.766 184.257Z",
    fill: "url(#paint0_linear_6430_6871)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3189 87.9463H179.47C182.882 87.9463 185.955 90.8569 185.955 94.4524V152.151C185.955 155.575 183.053 158.657 179.47 158.657H88.3189C84.9051 158.657 81.8325 155.746 81.8325 152.151V94.4524C81.8325 90.8569 84.9051 87.9463 88.3189 87.9463Z",
    fill: "#384252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.48 89.7129C225.816 87.525 225.973 83.9309 223.791 81.5868C221.61 79.2428 218.026 79.0864 215.69 81.2743C213.353 83.4621 213.196 87.0563 215.378 89.4003C217.404 91.5881 221.143 91.9007 223.48 89.7129Z",
    fill: "url(#paint1_linear_6430_6871)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M223.791 63.9282C224.726 62.9906 224.881 61.4279 223.948 60.4902C223.013 59.5527 221.454 59.3965 220.519 60.334C219.585 61.2716 219.429 62.8344 220.364 63.772C221.299 64.8659 222.856 64.8659 223.791 63.9282Z",
    fill: "url(#paint2_linear_6430_6871)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.563 28.4548C163.185 27.8298 163.342 26.7359 162.718 26.1108C162.096 25.4858 161.005 25.3294 160.382 25.9546C159.758 26.5797 159.603 27.6735 160.226 28.2986C160.849 28.9238 161.939 29.08 162.563 28.4548Z",
    fill: "url(#paint3_linear_6430_6871)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6430_6871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.07 57.4704L196.368 98.0477C195.515 99.4173 193.808 99.9311 192.613 99.075L153.695 76.3038C152.329 75.4478 151.817 73.7355 152.671 72.5371L182.542 20.8311C183.395 19.4613 185.102 18.9477 186.297 19.8038L214.462 36.2402L219.07 57.4704Z",
    fill: "#4A5463"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.46 36.2402L207.975 47.1978C207.122 48.9099 207.633 50.622 209.169 51.6493L218.899 57.2994",
    fill: "#384252"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.662 46.8552C188.346 46.6841 189.028 46.6841 189.54 46.6841C190.224 46.6841 190.906 46.6841 191.589 46.6841C192.271 46.8552 193.126 47.0264 193.808 47.1976C194.662 47.5401 195.344 47.8825 196.028 48.2249C197.051 48.7385 197.904 49.4235 198.588 50.2795C199.27 50.9643 199.782 51.8204 200.124 52.8477C200.466 53.7037 200.466 54.731 200.466 55.5871C200.295 56.6144 199.953 57.6417 199.44 58.4977C198.929 59.3538 198.417 60.0386 197.733 60.7234C197.051 61.2371 196.539 61.5794 195.686 61.9219C195.002 62.2642 194.32 62.4355 193.637 62.4355L191.76 62.6067C191.248 62.6067 190.735 62.778 190.053 62.9492C189.54 63.1203 189.199 63.2915 188.859 63.634L186.98 66.0309L183.908 64.3188L185.273 61.2371C185.444 60.7234 185.957 60.2098 186.297 59.8673C186.809 59.5248 187.322 59.3538 187.833 59.1825C188.517 59.0113 189.028 59.0113 189.711 58.84C190.395 58.84 191.077 58.6688 191.76 58.4977C192.442 58.3265 192.955 58.1552 193.637 57.8127C194.32 57.4704 194.662 56.9567 195.002 56.2719C195.173 55.9294 195.344 55.4158 195.515 54.9023C195.515 54.3885 195.515 54.0461 195.344 53.7037C195.173 53.19 195.002 52.8477 194.662 52.5052C194.32 52.1629 193.979 51.8204 193.466 51.4779C192.955 51.1356 192.271 50.7931 191.589 50.6219C191.077 50.4506 190.564 50.4506 190.053 50.4506C189.54 50.4506 189.199 50.4506 188.859 50.4506C188.688 50.4506 188.346 50.4506 188.175 50.2795C187.833 50.1083 187.493 49.5946 187.493 49.2522L187.662 46.8552ZM178.957 69.4553C179.128 69.1128 179.47 68.7703 179.811 68.428C180.153 68.2568 180.493 67.9143 180.835 67.9143C181.689 67.743 182.542 67.743 183.226 68.2568C183.566 68.428 183.908 68.7703 184.249 69.1128C184.42 69.4553 184.591 69.7976 184.76 70.1401C185.273 71.8522 184.249 73.3931 182.542 73.9068C181.689 74.0779 180.835 73.9068 180.153 73.5643C179.811 73.3931 179.47 73.0507 179.128 72.7083C178.957 72.3658 178.617 72.0234 178.617 71.681C178.446 71.3385 178.446 70.8249 178.617 70.4824C178.617 70.1401 178.788 69.7976 178.957 69.4553Z",
    fill: "#A0B1BB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6430_6871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1272 39.8352L99.0727 67.058C99.9261 68.0852 99.9261 69.455 98.9019 70.3111L72.4444 95.4792C71.4203 96.3353 70.0548 96.3353 69.2013 95.308L36.0868 60.2095C35.2333 59.1823 35.2333 57.8126 36.2575 56.9566L55.5459 38.8081L73.1272 39.8352Z",
    fill: "#4A5463"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.375 38.4658L62.5441 45.999C63.5683 47.0263 65.2752 47.0263 66.2994 45.999L72.9565 39.6642",
    fill: "#384252"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4231 61.9218C57.4231 61.4082 57.5938 60.8945 57.7645 60.3809C57.9353 59.8672 58.106 59.3537 58.2766 58.8401C58.4473 58.3264 58.7887 57.8128 59.13 57.2991C59.4715 56.7855 59.9835 56.2718 60.4956 55.7582C61.1784 55.0734 61.8611 54.5597 62.7146 54.2173C63.3975 53.8749 64.2509 53.7036 64.9336 53.7036C65.6164 53.7036 66.4698 53.8749 67.1527 54.0461C67.8355 54.3884 68.5182 54.9021 69.2009 55.4157C69.7131 55.9294 70.2251 56.6143 70.3958 57.2991C70.5666 57.8128 70.7373 58.4976 70.9078 59.1824C70.9078 59.6961 70.9078 60.3809 70.9078 60.8945C70.7373 61.4082 70.7373 61.9218 70.5666 62.4355C70.5666 62.9491 70.3958 63.2916 70.3958 63.8051C70.3958 64.1476 70.3958 64.49 70.7373 64.8324L72.1027 66.887L70.0544 68.7704L68.0062 66.887C67.6647 66.5445 67.3233 66.2021 67.1527 65.6885C66.982 65.1749 66.982 64.8324 66.982 64.3189C66.982 63.8051 67.1527 63.2916 67.1527 62.7779C67.3233 62.2643 67.3233 61.7506 67.3233 61.237C67.3233 60.7233 67.3233 60.2097 67.1527 59.6961C66.982 59.1824 66.6406 58.6688 66.2993 58.1551C66.1286 57.8128 65.7871 57.6416 65.4457 57.4703C65.1044 57.2991 64.7629 57.2991 64.4216 57.2991C64.0802 57.2991 63.7387 57.4703 63.3975 57.6415C63.056 57.8128 62.7146 57.9839 62.3733 58.3264C62.0318 58.6688 61.6905 59.1824 61.3491 59.5249C61.1784 59.8672 61.0077 60.2097 60.8371 60.7233C60.6664 61.0658 60.6664 61.4082 60.6664 61.5795C60.6664 61.7506 60.4956 61.9218 60.3249 62.093C60.1542 62.4355 59.6422 62.4355 59.3007 62.2643L57.4231 61.9218ZM73.1269 73.9067C72.9562 73.7354 72.7855 73.3931 72.6149 73.0506C72.4442 72.7081 72.4442 72.3658 72.4442 72.0233C72.4442 71.3385 72.7855 70.6537 73.2977 70.14C73.4684 69.9687 73.8097 69.7977 74.1511 69.6264C74.4924 69.4552 74.8338 69.4552 75.1753 69.4552C76.1995 69.4552 77.2235 70.14 77.5649 71.1673C77.7357 71.5098 77.7357 71.8521 77.7357 72.1946C77.7357 72.5369 77.5649 72.8794 77.5649 73.2219C77.3942 73.5642 77.2235 73.7354 76.8822 74.0779C76.7115 74.2492 76.37 74.5915 76.0288 74.5915C75.346 74.7627 74.6631 74.7627 74.1511 74.5915C73.6389 74.4202 73.2977 74.2492 73.1269 73.9067Z",
    fill: "#A0B1BB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6430_6871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.893 82.6387L130.822 118.764C130.48 119.963 129.115 120.819 127.92 120.305L92.9279 110.033C91.733 109.69 90.8796 108.321 91.3916 107.122L105.047 60.5523C105.388 59.3539 106.754 58.4978 107.949 59.0114L133.382 66.5448L140.893 82.6387Z",
    fill: "#4A5463"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.386 66.6079L130.139 76.8173C129.798 78.1869 130.651 79.7278 132.017 80.0703L141.02 82.6219",
    fill: "#384252"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.093 80.4127C114.606 80.2414 115.118 80.0702 115.63 79.899C116.142 79.7277 116.654 79.5566 117.337 79.5566C118.019 79.5566 118.531 79.5566 119.214 79.5566C119.897 79.5566 120.58 79.7277 121.262 79.899C122.116 80.0702 122.969 80.5838 123.652 81.0975C124.335 81.6111 124.847 82.1248 125.359 82.8096C125.701 83.4944 126.042 84.1794 126.213 84.8642C126.383 85.7202 126.213 86.5763 126.042 87.2611C125.871 87.9459 125.53 88.6309 125.018 89.3157C124.676 89.8293 124.164 90.343 123.652 90.6853C123.14 91.0278 122.628 91.3703 122.116 91.5414L120.58 92.0551C120.238 92.2263 119.726 92.3974 119.385 92.5686C119.044 92.7399 118.702 93.0824 118.702 93.4247L117.678 95.6505L114.947 94.452L115.459 91.7126C115.459 91.199 115.8 90.8565 116.142 90.5142C116.483 90.1717 116.824 89.8293 117.337 89.658C117.849 89.4869 118.361 89.3157 118.702 89.1444C119.214 88.9732 119.726 88.802 120.238 88.4596C120.75 88.2884 121.092 87.9459 121.604 87.6036C121.945 87.2611 122.287 86.7475 122.457 86.0626C122.457 85.8915 122.457 85.549 122.457 85.2065C122.457 84.8642 122.287 84.5217 122.116 84.1794C121.945 83.8369 121.604 83.6657 121.262 83.3232C120.921 83.1521 120.58 82.9808 120.068 82.8096C119.556 82.6384 119.044 82.6384 118.361 82.6384C118.019 82.6384 117.507 82.6384 117.166 82.8096C116.824 82.8096 116.483 82.9808 116.312 82.9808C116.142 82.9808 115.971 83.1521 115.63 82.9808C115.288 82.9808 114.947 82.6384 114.947 82.296L114.093 80.4127ZM111.533 100.102C111.704 99.7595 111.704 99.4172 112.045 99.246C112.216 98.9035 112.557 98.7324 112.728 98.5612C113.411 98.2187 114.093 98.2187 114.606 98.3899C114.947 98.5612 115.288 98.7323 115.459 98.9035C115.63 99.0747 115.971 99.4172 116.142 99.5885C116.824 100.787 116.312 102.328 115.118 102.841C114.435 103.184 113.752 103.184 113.24 103.013C112.899 102.841 112.557 102.841 112.386 102.499C112.045 102.328 111.874 101.985 111.704 101.814C111.533 101.472 111.533 101.301 111.362 100.958C111.533 100.787 111.533 100.445 111.533 100.102Z",
    fill: "#A0B1BB"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6430_6871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.168 144.446L190.053 162.423C189.028 162.936 187.491 162.595 186.98 161.396L170.422 129.037C169.911 128.01 170.251 126.469 171.447 125.955L214.462 103.184C215.486 102.67 217.022 103.013 217.533 104.211L229.482 127.667L223.168 144.446Z",
    fill: "#4A5463"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M229.311 128.01L220.093 132.804C218.899 133.489 218.388 135.201 218.899 136.399L222.995 144.617",
    fill: "#384252"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.439 123.558C206.951 123.729 207.293 124.072 207.804 124.243C208.317 124.414 208.658 124.757 209.169 125.27C209.682 125.784 210.024 126.126 210.364 126.64C210.877 127.154 211.218 127.667 211.56 128.352C212.071 129.037 212.242 130.064 212.242 130.749C212.413 131.605 212.242 132.29 212.242 133.146C212.071 133.831 211.73 134.516 211.389 135.2C210.877 135.885 210.195 136.399 209.511 136.742C208.999 137.084 208.146 137.255 207.462 137.426C206.951 137.598 206.097 137.598 205.586 137.426C205.073 137.255 204.391 137.255 203.878 136.913L202.513 136.228C202.171 136.057 201.659 135.885 201.318 135.714C200.977 135.543 200.464 135.543 200.293 135.885L198.075 136.742L196.88 134.173L199.099 132.632C199.44 132.29 199.953 132.29 200.464 132.29C200.977 132.29 201.318 132.29 201.829 132.461C202.342 132.632 202.684 132.975 203.024 133.146C203.537 133.317 203.878 133.66 204.56 133.831C205.073 134.002 205.415 134.002 206.097 134.173C206.609 134.173 207.122 134.002 207.804 133.66C208.317 133.317 208.999 132.804 208.999 131.948C209.169 131.605 208.999 131.263 208.999 130.749C208.828 130.407 208.828 130.064 208.488 129.55C208.317 129.037 207.975 128.694 207.633 128.181C207.462 128.01 207.122 127.667 206.78 127.496C206.609 127.325 206.268 127.154 206.097 126.982C205.926 126.811 205.757 126.811 205.586 126.469C205.415 126.298 205.415 125.784 205.586 125.613L206.439 123.558ZM190.564 135.372C190.906 135.2 191.077 135.029 191.588 135.2C191.929 135.029 192.271 135.2 192.442 135.2C193.124 135.372 193.637 135.885 193.808 136.399C193.978 136.742 193.978 137.084 193.978 137.426C193.978 137.598 193.978 138.111 193.978 138.282C193.808 138.796 193.295 139.481 192.784 139.652C192.442 139.823 192.1 139.823 191.759 139.823C191.588 139.823 191.077 139.823 190.906 139.823C190.222 139.652 189.711 139.138 189.54 138.625C189.369 138.282 189.369 137.94 189.369 137.598C189.199 137.255 189.369 136.913 189.369 136.742C189.54 136.399 189.711 136.228 189.711 135.885C189.882 135.714 190.393 135.714 190.564 135.372Z",
    fill: "#A0B1BB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M187.662 125.099V153.52C187.662 157.116 184.589 160.198 181.006 160.198H87.2945C83.71 160.198 80.6375 157.116 80.6375 153.52V122.702",
    stroke: "#1676EE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.078 106.779H151.988C148.915 106.779 145.843 107.807 143.453 109.861L134.918 116.71C132.529 118.593 129.456 119.791 126.384 119.791H89.8553C86.2708 119.791 83.1982 122.702 83.1982 126.469C83.1982 126.811 83.1982 127.153 83.369 127.496L90.0261 162.595C90.5381 165.847 93.4399 168.416 96.683 168.416H174.69C178.104 168.416 180.835 166.018 181.348 162.766L190.735 114.484C191.248 110.888 188.857 107.464 185.102 106.95C184.76 106.779 184.419 106.779 184.078 106.779Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6430_6871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.955 100.445H154.719C151.134 100.445 147.379 101.814 144.648 104.04L134.406 112.43C131.504 114.827 127.92 116.025 124.335 116.025H80.4671C76.1999 116.025 72.4446 119.449 72.4446 124.072C72.4446 124.414 72.4446 124.928 72.6153 125.27L80.6379 167.902C81.3206 171.84 84.5639 174.922 88.6604 174.922H181.688C185.615 174.922 189.028 172.011 189.711 168.074L200.806 109.69C201.489 105.41 198.587 101.13 194.149 100.445C193.807 100.445 193.295 100.445 192.955 100.445Z",
    fill: "url(#paint4_linear_6430_6871)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.215 145.302C121.434 145.302 123.311 143.419 123.311 141.193C123.311 138.967 121.434 137.084 119.215 137.084C116.996 137.084 115.118 138.967 115.118 141.193C115.118 143.419 116.996 145.302 119.215 145.302Z",
    fill: "#B8C5CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.134 144.617C153.353 144.617 155.231 142.734 155.231 140.508C155.231 138.282 153.353 136.399 151.134 136.399C148.915 136.399 147.038 138.282 147.038 140.508C147.038 142.734 148.915 144.617 151.134 144.617Z",
    fill: "#B8C5CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M143.794 151.466H141.575C139.698 147.699 135.089 146.158 131.504 148.213C129.968 148.898 128.773 150.267 128.261 151.466H126.042C127.92 146.501 133.553 143.933 138.332 145.816C140.892 146.843 142.77 148.898 143.794 151.466Z",
    fill: "#B8C5CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.487 188.791C206.609 188.791 207.293 188.961 192.784 174.408C178.787 184.852 159.328 174.75 159.328 157.63C159.328 146.158 168.716 136.742 180.153 136.742C196.709 136.742 206.951 155.404 197.222 169.615L210.706 183.14C212.926 185.195 211.56 188.791 208.487 188.791ZM180.322 143.419C172.471 143.419 165.984 149.754 165.984 157.801C165.984 165.847 172.3 172.183 180.322 172.183C181.177 172.183 182.029 172.183 182.884 172.011C183.737 171.84 184.589 171.668 185.273 171.327C186.126 170.984 186.809 170.642 187.491 170.299C188.346 169.786 189.028 169.272 189.711 168.588C190.224 168.074 190.906 167.388 191.418 166.876C191.929 166.19 192.442 165.506 192.784 164.82C193.126 164.136 193.466 163.279 193.808 162.424C194.149 161.568 194.32 160.711 194.32 159.855C194.32 159.171 194.491 158.657 194.491 157.972C194.66 149.754 188.175 143.419 180.322 143.419Z",
    fill: "#828A99"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110 135.325L119.217 130.36L110 135.325Z",
    fill: "#B8C5CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110 135.325L119.217 130.36",
    stroke: "#989FB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M159.156 133.136L149.939 128L159.156 133.136Z",
    fill: "#B8C5CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M159.156 133.136L149.939 128",
    stroke: "#989FB0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6430_6871",
    x: 130.253,
    y: 8.38525,
    width: 110.816,
    height: 124.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6430_6871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6430_6871",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6430_6871",
    x: 13.4666,
    y: 27.8081,
    width: 108.226,
    height: 101.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6430_6871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6430_6871",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6430_6871",
    x: 69.24,
    y: 47.8594,
    width: 93.6528,
    height: 105.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6430_6871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6430_6871",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6430_6871",
    x: 148.192,
    y: 91.9526,
    width: 103.29,
    height: 103.702,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6430_6871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6430_6871",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6430_6871",
    x: 50.4446,
    y: 89.4448,
    width: 172.461,
    height: 118.477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6430_6871"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6430_6871",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6430_6871",
    x1: 137.496,
    y1: 5.55994,
    x2: 135.952,
    y2: 85.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6430_6871",
    x1: 219.716,
    y1: 77.6453,
    x2: 219.6,
    y2: 83.7275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6430_6871",
    x1: 222.211,
    y1: 58.8141,
    x2: 222.16,
    y2: 61.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6430_6871",
    x1: 161.51,
    y1: 24.959,
    x2: 161.476,
    y2: 26.7055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253040",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6430_6871",
    x1: 136.675,
    y1: 100.445,
    x2: 136.675,
    y2: 174.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D6675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C5460"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAssets);
export default __webpack_public_path__ + "static/media/no-assets.88da59024128438a5d1bd3cd4846d5d8.svg";
export { ForwardRef as ReactComponent };